import React, { useContext, useState } from "react";
import { rootContexts } from "../../contexts/rootContexts";
import EmailField from "../Form/EmailField";
import PasswordFiled from "../Form/PasswordField";
import SubmitField from "../Form/SubmitField";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { loginService } from "../../services/authServices";
import * as yup from "yup";
import { emailValidation, passwordValidation } from "../../utils/validation";
import errorModel from "../Errors/ErrorModel";


export default function Login() {
  const [loader, setLoader] = useState(false);
  const { setAsLogin } = useContext(rootContexts);

  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      email: emailValidation,
      password: passwordValidation,
    }),
    onSubmit: async (values) => {
      setLoader(true);
      const result = await loginService(values);
      console.log(result, "result22");
      if (result.status) {
        if (result.account.role === "User") {
          localStorage.setItem("token", result.accessToken);
          setLoader(false);
          setAsLogin(false);
          navigate("/");
        } 
        else if(result.account.role === "Primary" || result.account.role === "Secondary"){
          window.location.href = `https://sdsadmin.dev-bt.xyz/authenticator?token=${result.accessToken}&data=${JSON.stringify(result.account)}`;
          setLoader(false);
          setAsLogin(false);
        }
      } else {
        setLoader(false);
        console.log(result.message, 'result.message')
        errorModel("error", result.message);
        // setAsLogin(false)
      }
    },
  });
  return (
    <>
      <div className="mt-2 border-2 border-beta p-4 rounded">
        <h1 className="h2 text-center">Login</h1>

        <form onSubmit={formik.handleSubmit} className="px-5 md:px-10">
          <EmailField
            label="Email"
            name="email"
            placeholder="Email"
            formik={formik}
          />
          <PasswordFiled
            label="Password"
            name="password"
            placeholder="password"
            formik={formik}
          />
          <div className=" py-2">
            <SubmitField label="Sign in" loader={loader} />
            <Link
              to="/forget-password"
              onClick={() => setAsLogin(false)}
              className="font-imprima text-xs underline text-info"
            >
              Forget Password
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}
